import React from "react";
import { Card } from "react-bootstrap";

export default function PickerEmptyCard({
  label,
  onSelect,
  selected = false,
  pickerKey
}) {
  return (
    <Card
      className={`h-100 shadow-sm ${selected ? "border-primary" : ""}`}
      style={{ maxWidth: 220, margin: "0 auto" }}
    >
      <button
        type="button"
        className="border-0 bg-transparent p-2 w-100 h-100"
        data-picker-nav="item"
        data-picker-nav-empty="true"
        data-picker-key={pickerKey}
        onClick={onSelect}
        aria-pressed={selected}
      >
        <div
          aria-hidden="true"
          className="d-flex align-items-center justify-content-center text-muted"
          style={{ height: 100, fontSize: "2rem" }}
        >
          ∅
        </div>
        <div className="mt-2 text-break">{label}</div>
      </button>
    </Card>
  );
}
